import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { emptyAuthorizedCert, IAuthorizedCert } from '../../../model/authorized-cert';
import { emptyAuthorizedPerson, IAuthorizedPerson } from '../../../model/authorized-person';
import { AuthorizedService } from '../../../services/authorized.service';
import { emptyAuthorized, IAuthorized } from '../../../model/authorized';
import { IHttpErrorsResponse } from '../../../model/http-errors-response';
import { IPerson } from '../../../model/person';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-inv-authorized-list',
  templateUrl: './inv-authorized-list.component.html',
  styleUrls: ['./inv-authorized-list.component.css']
})
export class InvAuthorizedListComponent implements OnInit {

  @Input() person: IPerson;

  /**
   *
   * @type {IAuthorized[]}
   */

  authorizedList: IAuthorized[] = [];

  /**
   *
   * @type {IAuthorizedPerson}
   */
  authorizedPerson: IAuthorizedPerson = emptyAuthorizedPerson;

  /**
   *
   * @type {IAuthorizedCert}
   */
  authorizedCert: IAuthorizedCert = emptyAuthorizedCert;

  /**
   *
   * @type {IAuthorized}
   */
  authorized: IAuthorized = emptyAuthorized;

  /**
   * @type {string}
   */
  type: string = '';

  /**
   *
   * @type {boolean}
   */
  isFileLoaded: boolean = false;

  /**
   * @type {IHttpErrorsResponse}
   */
  errors: IHttpErrorsResponse;

  /**
   * Inidica si se muestra o no la fila de nuevo autorizado
   * @type {boolean}
   */
  swNewAuthorized: boolean = false;

  /**
   * Contenido del panel modal para eliminar un autorizado
   */
  @ViewChild('modalDeleteAuthorized')
  modalDeleteAuthorized: TemplateRef<any>;

  constructor(private authorizedService: AuthorizedService,
              private modalService: NgbModal) { }


  ngOnInit() {
    this.initAuthorizedList();
  }

  /**
   *
   */
  initAuthorizedList() {
    this.authorizedService.getAuthorizeds(this.person).subscribe(
      result => {
        this.authorizedList = result;
      },
      error => {
        this.errors = error;
      });
  }

  /**
   *
   */
  onSaveAuthorizedsClicked() {
    this.authorizedService.saveAuthorized(this.getAuthorized())
      .subscribe(result => {
          this.clearState();
          this.initAuthorizedList();
        },
        error => {
          this.errors = error;
          console.log(this.errors.errors);
        });
  }

  /**
   *
   * @return {IAuthorized}
   */
  getAuthorized(){
    if(this.type === 'Person'){
      this.authorizedPerson.person = this.person;
      this.authorizedPerson.type = 'Person';
      this.authorized = this.authorizedPerson;
    }else if(this.type === 'Certificate'){
      this.authorizedCert.person = this.person;
      this.authorizedCert.type = 'Certificate';
      this.authorized = this.authorizedCert;
    }

    return this.authorized;
  }

  /**
   *
   * @param event
   */
  uploadFile(event): void {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.authorizedCert.certificate.id = -1;
        this.authorizedCert.certificate.file = reader.result.split(',')[1];
        this.authorizedCert.certificate.issuer = file.name;
        this.isFileLoaded = true;
      }
    }
  }

  /**
   *
   */
  clearState() {
    this.errors = null;
    this.authorizedPerson = emptyAuthorizedPerson;
    this.authorizedCert = emptyAuthorizedCert;
    this.authorizedCert.certificate.issuer = '';
    this.authorizedCert.certificate.file = null;
    this.authorizedPerson.authorizedPerson.identifier = '';
    this.type = '';
    this.isFileLoaded = false;
    this.swNewAuthorized = false;
  }

  /**
   * cancelInvoicingService
   */
  cancelInvoicingService() {
    this.clearState();
  }

  /**
   * Metodo invocado para aniadir un nuevo autorizado
   */
  onNewAthorizedClicked() {
    this.swNewAuthorized = true;
  }

  /**
   *
   * @param {IAuthorized} authorized
   * @param {number} index
   */
  openDeleteAuthorized(authorized: IAuthorized, index: number) {
    this.modalService.open(this.modalDeleteAuthorized).result.then((result) => {
      if (result === 'remove') {
        this.authorizedService.deleteAuthorized(this.person, authorized)
          .subscribe(() => {
            this.authorizedList.splice(index, 1);
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv-authorized-list/inv-authorized-list.component.ts